export default __webpack_public_path__ + "static/media/apple.8905cb12.png";